import localforage from 'localforage'
import * as Sentry from '@sentry/vue'

export default {
  methods: {
    async checkUnfinishedUploads(targetSlideId, store) {
      try {
        if (!targetSlideId) return
        const currentTasks = await localforage.getItem(store) || {}
        if (Object.keys(currentTasks).length > 0) {
          Object.keys(currentTasks)
            .filter((i) => i === targetSlideId)
            .forEach(async (slideId) => {
              if (currentTasks[slideId] &&
              currentTasks[slideId].presentationId &&
              currentTasks[slideId].retryTime < 3 &&
              this.presentation &&
              this.presentation.id === currentTasks[slideId].presentationId
              ) {
                await this.handleUpdateInBackground(currentTasks[slideId], slideId)
              }
            })
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    },

    async addUploadTask(slideId, presentationId, data, store) {
      try {
        const currentTasks = await localforage.getItem(store) || {}
        currentTasks[slideId] = data
        currentTasks[slideId].presentationId = presentationId
        currentTasks[slideId].retryTime = 0
        await localforage.setItem(store, currentTasks)
      } catch (error) {
        Sentry.captureException(error)
      }
    },

    async increaseRetryTime(slideId, store) {
      try {
        const currentTasks = await localforage.getItem(store) || {}
        const currentRetryCount = currentTasks[slideId].retryTime
        currentTasks[slideId].retryTime = currentRetryCount + 1
        await localforage.setItem(store, currentTasks)
      } catch (error) {
        Sentry.captureException(error)
      }
    },

    async removeUploadTask(slideId, store) {
      try {
        const currentTasks = await localforage.getItem(store) || {}
        if (currentTasks[slideId]) {
          delete currentTasks[slideId]
        }
        await localforage.setItem(store, currentTasks)
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
}
